import type { ExtendedWretchError } from '@/modules/query-client/types/ExtendedWretchError';
import { WretchError } from 'wretch/resolver';

/**
 * Check if the error is an extended WretchError
 * @param error - The error to check
 * @returns True if the error is an extended WretchError, false otherwise
 */
export default function isExtendedWretchError(
  error: Error | WretchError
): error is ExtendedWretchError {
  return (
    error instanceof WretchError &&
    'isExtended' in error &&
    error.isExtended === true
  );
}
